import ListaBancos from "./ListaBancos";
import Segmento from "./Segmento";
import Banco from "./Banco";
import * as moment from "moment";

export default abstract class SimuladorBase {
  public prazo: number;
  public tipoImovel: string;
  public statusImovel: string;
  public tempoContrucao: number;
  public dtNascimento: string;
  public selected: any = {};
  public listaBancos: ListaBancos;
  public uf: string = "";

  //
  public primeiraPrestacao: number;

  constructor(listaBancos: ListaBancos) {
    this.listaBancos = listaBancos;
  }

  // métodos obrigatórios
  abstract getOpcao(lista: Array<any>, banco: Banco, segmento: Segmento);
  abstract getEnquadramento(): string;

  public set(prop, value) {
    this[prop] = value;
  }

  public getIdadeMeses(): number {
    return Math.round(moment().diff(moment(this.dtNascimento), "months", true));
  }

  public getUfLimiteSFH(): number {
    if (this.listaBancos.estadosSFH[this.uf])
      return Number(this.listaBancos.estadosSFH[this.uf]);

    return 0;
  }

  public getValorMinPermitido(): number {
    var min = 0;
    for (let banco of this.listaBancos.list)
      for (let segmento of banco.segmentos)
        min =
          min == 0 ? segmento.valorMinimo : Math.min(min, segmento.valorMinimo);

    return min;
  }

  public getPrazoMin(): number {
    var min = 0;
    for (let banco of this.listaBancos.list)
      for (let segmento of banco.segmentos)
        if (segmento.tipo == this.tipoImovel)
          min =
            min == 0
              ? segmento.prazoMinimo
              : Math.min(min, segmento.prazoMinimo);

    return min;
  }

  public getMaiorPrazoMaxPermitido(): number {
    var max = 0;
    for (let banco of this.listaBancos.list)
      for (let segmento of banco.segmentos)
        if (segmento.tipo == this.tipoImovel)
          max = Math.max(max, this.prazoMaximoPermitido(segmento));

    return max;
  }

  public prazoLimite(segmento: Segmento): number {
    let max = this.prazoMaximoPermitido(segmento);
    return this.prazo < max ? this.prazo : max;
  }

  public prazoMaximoPermitido(segmento: Segmento): number {
    if (
      this.listaBancos.idadeMaxima - this.getIdadeMeses() >
      segmento.prazoMaximo
    )
      return segmento.prazoMaximo;
    else return this.listaBancos.idadeMaxima - this.getIdadeMeses();
  }

  public select(opcao: any) {
    this.selected = opcao;
  }

  // public getOpcoes(): Array<any> {
  // 	let lista: Array<any> = [];
  // 	for (let banco of this.listaBancos.list) {
  // 		for (let segmento of banco.segmentos) {
  // 			if (segmento.tipo == this.tipoImovel /* tipo do imovel */) {
  // 				this.getOpcao(lista, banco, segmento);
  // 			}
  // 		}
  // 	}
  // 	return lista;
  // }
  public getOpcoes(): Array<any> {
    let lista: Array<any> = [];
    for (let banco of this.listaBancos.list) {
      //Retira-se os banco que há possibilida de consório temporariamente
      // Ainda nao há implementação no sistema para Consórcio
      // if(!banco.nome.includes("Consórcio")){
      for (let segmento of banco.segmentos) {
        if (segmento.tipo == this.tipoImovel /* tipo do imovel */) {
          this.getOpcao(lista, banco, segmento);
        }
      }
      // }
    }
    return lista;
  }

  /**
   * Retorna um array com todas as prestações e o atributo
   */
  public getParcelaAnual(): Array<any> {
    let parcelas = this.getParcelas();
    let parcelasAnual = [];

    // Percorre a lista de parcelas a cada 12 meses
    for (let index: number = 0; index < parcelas.length; index++) {
      if (index % 12 === 0 || index === 1) {
        parcelasAnual.push(Object.assign({}, parcelas[index]));
      }
    }

    // Se a ultima parcela da lista anual for menor que a ultima parcela, anexa a ultima parcela real
    if (
      parcelasAnual[parcelasAnual.length - 1].count <
      parcelas[parcelas.length - 1].count
    )
      parcelasAnual.push(parcelas[parcelas.length - 1]);

    return parcelasAnual;
  }

  /**
   * Retorna um array contendo todas as parcelas
   */
  public getParcelas(): Array<any> {
    let parcelas: Array<any> = [];

    //segmento: Segmento, valorFinanciamento: number, taxaJuros: number, prazo: number
    let banco: Banco = this.selected.banco;
    let segmento: Segmento = this.selected.segmento;
    let valorFinanciamento: number = this.selected.valorFinanciamento;
    let valorImovel: number = this.selected.valorImovel;
    let saldoDevedor: number = valorFinanciamento;
    let taxaJuros: number =
      (this.selected.enquadramento == "SFH"
        ? segmento.sfhMensal()
        : segmento.sfiMensal()) / 100;
    let prazo: number = this.selected.prazo;

    let amortizacao: number = 0;
    let prestacao: number = 0;
    let totalEncargos: number = 0;

    if (segmento.tabelaAmortizacao == "S")
      amortizacao = valorFinanciamento / prazo;
    else {
      prestacao =
        valorFinanciamento *
        (((1 + taxaJuros) ** prazo * taxaJuros) /
          ((1 + taxaJuros) ** prazo - 1));
    }

    while (
      saldoDevedor.toFixed(2) >
      (0.0).toFixed(2) /* && parcelas.length <= prazo*/
    ) {
      // Adiciona primeira linha apenas contendo o saldo devedor inicial
      if (parcelas.length == 0) {
        parcelas.push({
          count: "-",
          amortizacao: 0,
          juros: 0,
          segurosTarifas: 0,
          prestacao: 0,
          saldoDevedor: saldoDevedor,
        });
      }

      let dfi = segmento.seguroDFI(valorImovel);
      let mip = segmento.seguroMIP(
        saldoDevedor,
        this.getIdadeMeses() + parcelas.length - 1
      );
      let juros: number = saldoDevedor * taxaJuros;
      let segurosTarifas: number = dfi + mip + Number(banco.taxaAdm);

      // Amortização SAC
      if (segmento.tabelaAmortizacao == "S") {
        prestacao = amortizacao + juros + segurosTarifas;
        totalEncargos += prestacao;

        // Faz essa validação porque o saldo devedor por chegar ao final com um valor muito infimo
        // de sobra no arredondamento. Ex.: R$ 0,0000000000012
        saldoDevedor =
          saldoDevedor - amortizacao >= 0 ? saldoDevedor - amortizacao : 0;

        parcelas.push({
          count: parcelas.length,
          amortizacao: amortizacao,
          juros: juros,
          segurosTarifas: segurosTarifas,
          prestacao: prestacao,
          saldoDevedor: saldoDevedor,
        });
      }
      // Amortização PRICE
      else if (segmento.tabelaAmortizacao == "P") {
        amortizacao = prestacao - juros;

        // Faz essa validação porque o saldo devedor por chegar ao final com um valor muito infimo
        // de sobra no arredondamento. Ex.: R$ 0,0000000000012
        saldoDevedor =
          saldoDevedor - amortizacao >= 0 ? saldoDevedor - amortizacao : 0;

        parcelas.push({
          count: parcelas.length,
          juros: juros,
          mip: mip,
          dfi: dfi,
          tarifa: Number(banco.taxaAdm),
          segurosTarifas: segurosTarifas,
          prestacao: prestacao + segurosTarifas,
          amortizacao: amortizacao,
          saldoDevedor: saldoDevedor,
        });

        totalEncargos += prestacao + segurosTarifas;
      }

      if (parcelas.length == 2) this.primeiraPrestacao = totalEncargos;
    }

    return parcelas;
  }

  public validate(property: string): boolean {
    // Valida regras para financiamento

    switch (property) {
      case "dtNascimento":
        return (
          /^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/.test(
            this.dtNascimento
          ) && moment(this.dtNascimento).isValid()
        );

      case "prazo":
        return (
          this.prazo >= this.getPrazoMin() &&
          this.prazo <= this.getMaiorPrazoMaxPermitido()
        );

      default:
        return true;
    }
  }

  //////////
  // Convert Object to simulation
  public static convert(
    simulacao: SimuladorBase,
    object: any,
    listaBanco: ListaBancos
  ) {
    for (let key of Object.keys(object)) simulacao.set(key, object[key]);

    simulacao.selected.banco = Banco.convert(simulacao.selected.banco);
    simulacao.selected.segmento = new Segmento(simulacao.selected.segmento);

    return simulacao;
  }
}



// WEBPACK FOOTER //
// ./src/base/SimuladorBase.ts